var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTweetType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 77,
    viewBox: "0 0 85 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3075 0.564453H72.0891L71.9406 0.724784L47.2863 27.3564L27.3976 0.764982L27.2476 0.564453H26.9972H3.19542H2.19714L2.79501 1.3639L33.4305 42.3286L2.63309 75.5959L1.85576 76.4356H3H9.99536H10.2139L10.3623 76.2752L37.1663 47.3106L58.7938 76.2271L58.9438 76.4276H59.1942H83H83.9985L83.4004 75.6281L51.0221 32.3503L79.6698 1.40412L80.4471 0.564453H79.3029H72.3075ZM62.021 70.2828L14.4794 6.71725H24.1664L71.708 70.2828H62.021Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweetType);
export default __webpack_public_path__ + "static/media/tweetType.f1b1440b6318deba771df981723fef97.svg";
export { ForwardRef as ReactComponent };